import { useEffect, useState } from "react";
import { Article } from "@/mocks/gossip";
import SiteHeader from "./components/SiteHeader";
import Hero from "./components/Hero";
import HotList from "./components/HotList";
import Channels from "./components/Channels";
import Featured from "./components/Featured";
import Method from "./components/Method";
import About from "./components/About";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import SiteFooter from "./components/SiteFooter";
import ReaderModal from "./components/ReaderModal";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <a
      href="#home"
      className="fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
      aria-label="回到顶部"
    >
      <i className="ri-arrow-up-line h-5 w-5"></i>
    </a>
  );
}

export default function Home() {
  const [reading, setReading] = useState<Article | null>(null);

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <SiteHeader />
      <main>
        <Hero />
        <HotList />
        <Channels />
        <Featured onOpen={setReading} />
        <Method />
        <About />
        <Faq />
        <Contact />
      </main>
      <SiteFooter />
      <BackToTop />
      <ReaderModal article={reading} onClose={() => setReading(null)} />
    </div>
  );
}